import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface OccupancyChartProps {
    data: Array<{
        name: string
        reservas: number
        receita: number
    }>
}

export default function OccupancyChart({ data }: OccupancyChartProps) {
    if (!data || data.length === 0) return null

    return (
        <div className="bg-white p-10 rounded-[3.5rem] border border-[#001c28]/5 shadow-2xl shadow-[#001c28]/5">
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 rounded-2xl bg-[#001c28]/5">
                    <svg className="w-6 h-6 text-[#001c28]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
                <h3 className="text-xl font-black text-[#001c28] uppercase italic tracking-tighter">Ocupação por Espaço</h3>
            </div>

            <div className="h-80 w-full">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                        <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 10, fontWeight: 'bold', fill: '#6b7280' }}
                            angle={-45}
                            textAnchor="end"
                            height={80}
                            interval={0}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 11, fontWeight: 'bold', fill: '#6b7280' }}
                            label={{ value: 'Reservas', angle: -90, position: 'insideLeft', style: { fontSize: 11, fontWeight: 'bold', fill: '#6b7280' } }}
                        />
                        <Tooltip
                            contentStyle={{
                                borderRadius: '16px',
                                border: 'none',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                fontSize: '12px',
                                fontWeight: '700',
                                padding: '12px'
                            }}
                            cursor={{ fill: '#f8fafc' }}
                            formatter={(value: any) => [value, 'Reservas']}
                        />
                        <Bar
                            dataKey="reservas"
                            fill="#3b82f6"
                            radius={[12, 12, 0, 0]}
                            maxBarSize={60}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}
